
export function getQueryParameterByName(name: string, url: string): string {
    const params = new URLSearchParams(new URL(url).search);
    const paramValue = params.get(name);
    return paramValue != null ? decodeURIComponent(paramValue) : '';
}
